// rc-upload 2.6.0
import upload from './src';

export default upload;